//import {  get,  post,put,r_delete,displayimg} from '@/api/request';
import request from '@/components/libs/request'

class Model  extends request {
}
 



Model.reject = function(str) {
 return new Promise((resolve, reject) => {  reject(str) });
}



export default Model;



// WEBPACK FOOTER //
// ./src/components/model/model.js